import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const Banner = styled('section')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(2),
  boxSizing: 'border-box',
  width: '100%',
  borderRadius: 0,
  color: theme.palette.common.white,
  background: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
  overflow: 'visible'
}))

export const Content = styled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 532,
    margin: '0 auto'
  }
}))

export const Header = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12
})
export const HeaderContent = styled('div')({
  '& > *': {
    display: 'inline'
  }
})

export const ActivateButton = styled(Button)(({ theme }) => ({
  width: 'auto',
  paddingLeft: theme.spacing(2),
  height: 36,
  paddingRight: theme.spacing(2),
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,
  '&:hover': { backgroundColor: theme.palette.grey[100] }
}))

export const ActivatedRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}))

export const ActivatedText = styled(Typography)({
  fontWeight: 700,
  color: 'inherit'
})
